/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_OwnerInputs */

const en_case_field_owner = /** @type {(inputs: Case_Field_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

const pt_br2_case_field_owner = /** @type {(inputs: Case_Field_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietário`)
};

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Case_Field_OwnerInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_owner = /** @type {((inputs?: Case_Field_OwnerInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_OwnerInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_owner(inputs)
	return pt_br2_case_field_owner(inputs)
});